import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { NameTableColumn } from "./NameTableColumn";

import useActionCreator from "../../../../../../redux/hooks/useActionCreator";

import { NameResponseType } from "@type/inventory/name";
import { Pagination } from "@type/inventory/pagination";

import { TablePagination } from "@helpers/tablePagination";
import { DeleteConfirmationModal } from "@components";
import { NameState } from "@reducers/types/inventory/name-state";

export default function NameListTable({
  handleScrollToTop,
  handleQuery,
  settingsNameState,
}: {
  handleScrollToTop: () => void;
  handleQuery: (key: string, value: number | string) => void;
  settingsNameState: NameState;
}) {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] =
    useState<boolean>(false);
  const [itemId, setItemId] = useState<number>();
  const [itemName, setItemName] = useState<string>("");

  const { t } = useTranslation();

  const { getData, createSuccess, deleteSuccess, updateSuccess } =
    settingsNameState;

  const { data, pagination } = getData || ({} as NameResponseType);
  const { page, total } = pagination || ({} as Pagination);

  const { nameDeleteActionHandler, nameFetchByIdActionHandler } =
    useActionCreator();

  const closeConfirmationModel = () => setIsConfirmationModalOpen(false);

  const openConfirmationModel = (itemName: string, id: string | number) => {
    setItemId(id as number);
    setItemName(itemName);
    setIsConfirmationModalOpen(true);
  };

  const deleteAction = () => {
    closeConfirmationModel();
    nameDeleteActionHandler(itemId as number);
  };

  useEffect(() => {
    if (createSuccess === true) handleQuery("page", 1);
    else if (deleteSuccess === true) handleQuery("page", page);
    else if (updateSuccess === true) handleQuery("page", page);
  }, [createSuccess, deleteSuccess, updateSuccess]);

  return (
    <div className="pt-12 border-top">
      {isConfirmationModalOpen && (
        <DeleteConfirmationModal
          subtitle={itemName}
          isModalOpen={isConfirmationModalOpen}
          onClose={closeConfirmationModel}
          action={deleteAction}
        />
      )}
      <Table
        header={{
          title: t("INVENTORY_SETTINGS.NAME.HEADER"),
          badge: {
            label: `${total || 0}`,
            size: "sm",
            type: "primary",
          },
        }}
        columns={NameTableColumn(
          t,
          openConfirmationModel,
          nameFetchByIdActionHandler,
          handleScrollToTop,
        )}
        rows={data || []}
        pagination={TablePagination(pagination, handleQuery)}
      />
    </div>
  );
}
